<mat-table #table [dataSource]="dataSource" matSort matSortActive="created_at" matSortDirection="desc" matSortDisableClear
    [@animateStagger]="{value:'50'}">

    <!-- Employee Request Name Column -->
    <ng-container matColumnDef="request">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Request' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let request">
            <p class="text-truncate font-weight-600">{{request.employee_request_name}}</p>
        </mat-cell>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Status' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let request">
            <p class="text-truncate font-weight-600">{{request.status}}</p>
        </mat-cell>
    </ng-container>

    <!-- Comment Column -->
    <ng-container matColumnDef="comment">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs>{{'Admin Comment' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let request" fxHide.xs>
            <p class="text-truncate font-weight-600" matTooltipClass="tooltip" matTooltip="{{request.comment}}">{{request.comment}}</p>
        </mat-cell>
    </ng-container>

    <!-- Pick Up Date Column -->
    <ng-container matColumnDef="pick_up_date">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs>{{'Pick Up Date' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let request" fxHide.xs>
            <p class="text-truncate font-weight-600">{{request.pick_up_date}}</p>
        </mat-cell>
    </ng-container>

    <!-- Created at Column -->
    <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-md>{{'Date of Creation' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let request" fxHide.lt-md>
            <p class="text-truncate font-weight-600">{{request.created_at}}</p>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let request; columns: displayedColumns;" class="request" matRipple
        [@animate]="{value:'*',params:{y:'100%'}}">
    </mat-row>

</mat-table>
<mat-paginator #paginator [length]="totalElements" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]"
    [hidePageSize]="true" [fxHide]="totalElements === 0">
</mat-paginator>